import React from "react";

import whiteAngleDownIcon from "../../Images/angle-down.svg";
import whiteAngleUpIcon from "../../Images/angle-up-white.svg";
import deleteIcon from "../../Images/delete-icon.svg";
import onRecord from "../../Images/no-data.png";
  
import CounterDetails from "./CounterDetails";
import CounterHistory from "./CounterHistory";

export default function CounterCard({
  counter,
  isActive,
  onSelect,
  onDelete,
  onEdit,
  openCounterId,
  setOpenCounterId,
}) {
  const isOpen = openCounterId === counter.id;

  return (
    <div
      className={`counterItemWrapper__Items counterCard
        ${counter.isDisabled ? " counterCard--disabled" : ""}
        ${isActive ? " counterCard--active" : ""}`}
    >
      {/* Accent */}
      <div className="counterCard__accent" aria-hidden />

      {/* Main Card */}
      <div
        className={`counterCard__main ${
          counter.isDisabled ? "disabled" : ""
        }`}
        onClick={() => !counter.isDisabled && onSelect()}
      >
        <span
          className={`counterType ${
            counter.type === "daily" ? "daily" : "goal"
          }`}
        >
          {counter.type === "daily" ? "Daily" : "Goal"}
        </span>

        <p className="counterName">{counter.name}</p>

        <div className="counterDetails">
          <CounterDetails counter={counter} />
        </div>
      </div>

      {/* Accordion - History */}
      <div className="moreDetails-Acc">
        <button
          type="button"
          className="moreDetails-Acc__header"
          onClick={() =>
            setOpenCounterId(isOpen ? null : counter.id)
          }
          aria-expanded={isOpen}
          aria-label={`Toggle history log for ${counter.name}`}
        >
          <span className="moreDetails-Acc__title">
            History log
          </span>

          <span
            className="moreDetails-Acc__chevron"
            aria-hidden
          >
            <img
              src={isOpen ? whiteAngleUpIcon : whiteAngleDownIcon}
              alt=""
            />
          </span>
        </button>

        {isOpen && (
          <div className="moreDetails-Acc__body">
            {counter.history.length > 0 ? (
              <CounterHistory history={counter.history} />
            ) : (
              <div className="noRecord-found">
                <img
                  src={onRecord}
                  alt="No record found"
                />
              </div>
            )}
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="actions counterCard__actions">
        <div className="statusWrapper">
          <span className="statusText">Status</span>

          {counter.isDisabled ? (
            <span className="badge badge-completed">
              Completed
            </span>
          ) : isActive ? (
            <span className="badge badge-active">
              Active
            </span>
          ) : (
            <span
              className={`badge badge-${counter.status?.toLowerCase()}`}
            >
              {counter.status}
            </span>
          )}
        </div>

        <div className="actions__Item">
          <button
            type="button"
            className="iconButton counterCard__deleteBtn"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            aria-label={`Delete ${counter.name}`}
          >
            <img src={deleteIcon} alt="" title="Delete" />
          </button>
        </div>
      </div>
    </div>
  );
}